// extracted by mini-css-extract-plugin
export default {"modal":"ModalMPDVLead_modal__0ytqp","logo":"ModalMPDVLead_logo__nAycg","title":"ModalMPDVLead_title__3nLUW","img__container":"ModalMPDVLead_img__container__vjZm7"};